<template>
  <div class="row my-4 border p-3 rounded-2 me-3">
    <div class="title d-flex align-items-center justify-content-between">
      <div class="d-flex align-items-center justify-content-start flex-column">
        <h5 class="text-book mb-0 w-100">
          {{ $t("reserve_rate") }}
        </h5>
        <span>{{
          $t(
            "Display the rates of completed reservations in the selected period"
          )
        }}</span>
      </div>
      <div class="form-group w-25">
        <Multiselect
          v-model="nationalityValue_total_reves"
          :options="nationalities"
          :placeholder="$t('choose_nationality')"
          label="title"
          track-by="id"
          :clear-on-select="true"
          select-label=""
          :hide-selected="true"
          @keyup="searchNationality"
          @update:model-value="bookingss"
        >
        </Multiselect>
      </div>
    </div>

    <div class="card">
      <Chart type="bar" :data="Total" :options="TwoTotal" class="Books" />
    </div>
  </div>
</template>

<script>
import Chart from "primevue/chart";
import Multiselect from "vue-multiselect";
import axios from "axios";
export default {
  data() {
    return {
      Total: null,
      TwoTotal: null,
      nationalities: [],
      nationalityValue_total_reves: "",
      total_profit: 0,
      days: [],
      bookingssss: [],
      labels_bookings: [],
      labels_days: [],
    };
  },
  async mounted() {
    // this.Total = this.fetcgTotal();

    this.TwoTotal = this.fetchTot();

    await this.bookingss();
  },
  methods: {
    async searchNationality(event) {
      const searchText = {
        word: event == undefined ? "" : event.target.value,
      };
      await axios
        .post("/fetch_custom_countries", searchText)
        .then((res) => {
          // console.log(res.data.data.data, "searchNationality");
          this.nationalities = res.data.data.data;
        })
        .catch((err) => console.log(err));
    },
    fetcgTotal() {
      const documentStyle = getComputedStyle(document.documentElement);

      return {
        labels: this.labels_days,
        datasets: [
          {
            type: "line",
            label: this.$t("Profit rate"),
            borderColor: documentStyle.getPropertyValue("--blue-500"),
            borderWidth: 2,
            fill: true,
            tension: 0.4,
            data: this.labels_bookings,
          },
        ],
      };
    },
    fetchTot() {
      const documentStyle = getComputedStyle(document.documentElement);
      const textColor = documentStyle.getPropertyValue("--text-color");
      const textColorSecondary = documentStyle.getPropertyValue(
        "--text-color-secondary"
      );
      const surfaceBorder = documentStyle.getPropertyValue("--surface-border");
      return {
        maintainAspectRatio: false,
        aspectRatio: 0.6,
        plugins: {
          legend: {
            labels: {
              color: textColor,
            },
          },
        },
        scales: {
          x: {
            ticks: {
              color: textColorSecondary,
            },
            grid: {
              color: surfaceBorder,
            },
          },
          y: {
            ticks: {
              color: textColorSecondary,
            },
            grid: {
              color: surfaceBorder,
            },
          },
        },
      };
    },
    async bookingss() {
      const formData = new FormData();
      formData.append(
        "country_id",
        this.nationalityValue_total_reves.id == undefined
          ? 598
          : this.nationalityValue_total_reves.id
      );
      const res = await axios.post("/fetchBookingChart", formData);
      this.labels_days = res.data.data.days;
      this.labels_bookings = res.data.data.bookings;

      // this.labels_days.forEach((label) => {
      //   this.days.push(label);
      // });
      // this.labels_bookings.forEach((book) => {
      //   this.bookingssss.push(book);
      // });

      getComputedStyle(document.documentElement);

      // console.log(documentStyle.getPropertyValue("--orange-500"));

      this.Total = this.fetcgTotal();
    },
  },
  components: {
    Chart,
    Multiselect,
  },
};
</script>

<style lang="scss" scoped>
.text_point {
  color: #656b78;
  font-family: "regular";
  font-size: 0.8rem;
  margin: 0.5rem 0 0.5rem 0;
}
.bg-img {
  background: #0a909b;
}
.point {
  color: #0b1427;
  font-weight: bold;
  font-size: 1.3rem;
  display: flex;
  align-content: center;
  justify-content: flex-end;
  flex-direction: row-reverse;
}
.p-chart.h-80 {
  min-height: 28dvh;
}
.linechart {
  min-height: 28dvh;
}
.text-book {
  color: #0b1427;
  font-weight: bold;
  font-size: 1.2rem;
}
.Books {
  min-height: 28dvh;
  max-height: 28dvh;
  overflow-y: auto;
}
.text-point {
  color: #656b78;
  font-family: "regular";
  font-size: 1rem;
}
.points {
  color: #0b1427;
  font-size: 2rem;
  font-family: "bold";
}
thead {
  background-color: #eef4f4 !important;
  th.text-center {
    padding: 0.8rem;
  }
}
.pendding {
  color: #c57016;
}
.cancel {
  color: #e23535;
}
.accept {
  color: #2a8f6f;
}
.initial {
  color: #1664b8;
}
</style>
